module.exports = __webpack_public_path__ + "static/media/iphone-feedback.f412fb54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iphone-feedback.png
// module id = 1424
// module chunks = 0